import type {Theme} from "@src/features/settings/settings-models";


export function setThemeOnDocument(theme: Theme) {
	const root = window.document.documentElement;
	
	root.classList.remove("light", "dark");
	
	if (theme !== "system") {
		root.classList.add(theme);
		return;
	}
	
	const systemTheme = getSystemTheme();
	root.classList.add(systemTheme);
}


function getSystemTheme(): Theme {
	const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
		? "dark"
		: "light";
	return systemTheme;
}
